import { PlusIcon } from "lucide-react";
import { useEffect, useState } from "react";
import { cn } from "@/util/string";
import { Button } from "./catalyst/Button";

interface Props {
	onClick: () => void;
	label: string;
}

export function Fab({ onClick, label }: Props) {
	const [isVisible, setIsVisible] = useState(true);

	useEffect(() => {
		let timeoutId: ReturnType<typeof setTimeout>;

		const handleScroll = () => {
			setIsVisible(false);
			clearTimeout(timeoutId);
			timeoutId = setTimeout(() => {
				setIsVisible(true);
			}, 150);
		};

		window.addEventListener("scroll", handleScroll, { passive: true });

		return () => {
			window.removeEventListener("scroll", handleScroll);
			clearTimeout(timeoutId);
		};
	}, []);

	return (
		<div
			className={cn(
				`fixed bottom-8 right-8 z-50 transition-all duration-300 ease-in-out`,
				{
					"translate-y-0 opacity-100": isVisible,
					"translate-y-24 opacity-0": !isVisible,
				},
			)}
		>
			<Button
				color="dark/white"
				className="rounded-full! shadow-lg p-0 flex size-12 items-center justify-center before:rounded-full! after:rounded-full! cursor-pointer"
				onClick={onClick}
				aria-label={label}
			>
				<PlusIcon className="size-6!" />
			</Button>
		</div>
	);
}
